import { useTranslation } from "react-i18next";
import DividerWithText from "../../../../../components/DividerWithText";
import PhotoPickerSummary from "../../../../../components/PhotoPicker/PhotoPickerSummary";
import RowResumeText from "../../../../../components/RowResumeText";
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */

const VehicleSummary = ({ item, photoPicker }) => {

    const { t } = useTranslation();
    return (<div className='row'>
        <DividerWithText title={t('photography')} />
        <PhotoPickerSummary
            photoPicker={photoPicker}
            classWith={'w-400px'}
        />
        <DividerWithText title={t('details')} />
        <div className='mb-2 d-flex flex-column align-items-center gap-4 w-100'>
            <div className='row'>
                <div className='col-sm-12 col-md-6'>
                    <RowResumeText title={t('brand')} value={item?.brand} />
                </div>
                <div className='col-sm-12 col-md-6'>
                    <RowResumeText title={t('subBrand')} value={item?.subBrand} />
                </div>
                <div className='col-sm-12 col-md-6'>
                    <RowResumeText title={t('color')} value={item?.color} />
                </div>
                <div className='col-sm-12 col-md-6'>
                    <RowResumeText title={t('model')} value={item?.model} />
                </div>
                <div className='col-sm-12 col-md-6'>
                    <RowResumeText title={t('plates')} value={item?.plate} />
                </div>
                <div className='col-sm-12 col-md-6'>
                    <RowResumeText title={t('vin')} value={item?.vin} />
                </div>
                <div className='col-sm-12 col-md-6'>
                    <RowResumeText title={t('serial_number')} value={item?.serialNumber} />
                </div>
               
            </div>
        </div>

    </div>)
}

export default VehicleSummary;